<script lang="ts">
  import { fade } from 'svelte/transition';
  import { WidgetType } from '../enums/widget-type.enum';
  import { ConfigStore } from './../store/config';
  import LoadingTheme from './themes/loading-theme/loading-theme.svelte';
  import { LoadingThemeType } from '../enums/themes/loading-theme-type.enum';
</script>

{#if ![WidgetType.cb, WidgetType.chat, WidgetType.cip, WidgetType.ce, WidgetType.ctt, WidgetType.cmt].includes($ConfigStore.widgetType)}
  <div class="cs-search-loading" in:fade|global aria-hidden="true">
    <div />
    <div />
    <div />
    <div class="last" />
  </div>
{:else if $ConfigStore.customTheme?.loadingThemeType && $ConfigStore.customTheme?.loadingThemeType in LoadingThemeType}
  <div aria-hidden="true">
    <LoadingTheme />
  </div>
{:else}
  <div class="cs-search-loading-chat" transition:fade|global aria-hidden="true">
    <div id="dots">
      <span />
      <span />
      <span />
      <span />
    </div>
  </div>
{/if}
{#if $ConfigStore.customCSSUrl}
  {#if $ConfigStore.customCSSIntegrity}
    <link
      href={$ConfigStore.customCSSUrl}
      rel="stylesheet"
      type="text/css"
      integrity={$ConfigStore.customCSSIntegrity}
      crossorigin="anonymous"
    />
  {:else}
    <link href={$ConfigStore.customCSSUrl} rel="stylesheet" type="text/css" />
  {/if}
{/if}

<style lang="scss">
  @use './../../scss/components/_busy';
</style>
